import { KeysTabsAnalysis } from "@app/types/samples.types";
import Conditioning from "../../components/initialComponents/conditioning";
import Management from "../../components/initialComponents/management";
import Processing from "../../components/initialComponents/processing";
import Sampling from "../../components/initialComponents/sampling";
import { MapKeys } from "../../utils/constants";
import {
  conditioningMap,
  managementMap,
  processingMap,
  samplingMap,
} from "../../utils/helpers";

export const KeysInitialCode = {
  sampling: "sampling",
  management: "management",
  conditioning: "conditioning",
  processing: "processing",
};

// This file contains the configuration of the initial phases of the samples
export const setsInitialPhases: {
  label: string;
  set: string;
  endpoint: MapKeys;
  component: React.ComponentType<any>;
  functionMap: (data: any) => any;
  check: string;
}[] = [
  {
    label: "Toma de la muestra",
    set: KeysInitialCode.sampling,
    endpoint: "sampling",
    component: Sampling,
    functionMap: samplingMap,
    check: KeysInitialCode.management,
  },
  {
    label: "Gestión de muestra",
    set: KeysInitialCode.management,
    endpoint: "sample-management",
    component: Management,
    functionMap: managementMap,
    check: KeysInitialCode.conditioning,
  },
  {
    label: "Acondicionamiento",
    set: KeysInitialCode.conditioning,
    endpoint: "conditioning",
    component: Conditioning,
    functionMap: conditioningMap,
    check: KeysInitialCode.processing,
  },
  {
    label: "Procesamiento",
    set: KeysInitialCode.processing,
    endpoint: "processing",
    component: Processing,
    functionMap: processingMap,
    check: "analysis",
  },
];
